<template>
  <div>
    <b-row>
      <b-col
        class="mb-1"
      >
        <b-link
          v-if="userData.groupname !== 'psd'"
          style="font-size: 26px; color: #fff;"
          to="/analytic120-total"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /><span style="color: #00FF80;"> วิเคราะห์: </span>{{ wayname }}
        </b-link>
        <b-link
          v-if="userData.groupname === 'psd'"
          style="font-size: 26px; color: #fff;"
          to="/"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /><span style="color: #00FF80;"> วิเคราะห์: </span>{{ wayname }}
        </b-link>
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="12"
        class="text-sm-right"
        style="margin-bottom: 7px;"
      >
        <b-img
          v-if="(qrcode < 95 && qrcode > 99) || qrcode != 13 || qrcode === 93"
          src="@/assets/images/qrcode/black.jpeg"
          style="height: 70px; width: 70px;"
        />
        <b-img
          v-else-if="(qrcode >= 95 && qrcode <=99 || qrcode == 15 || qrcode == 13 || qrcode >= 46)"
          :src="require(`@/assets/images/qrcode/${qrcode}.jpg`)"
          style="height: 70px; width: 70px;"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 610px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <l-map
            ref="mymap"
            :zoom="zoom"
            :center="center"
            :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
            @update:zoom="zoomUpdated"
          >
            <l-tile-layer :url="url" />
            <l-marker
              v-for="(marker, index) in markers"
              :key="'marker'+index"
              :ref="'marker'+index"
              :lat-lng="[marker.latitude, marker.longitude]"
              :options="{ autoClose: false, closeOnClick: false }"
              @click="getInfoCount(marker.WayID, marker.detail, marker.id, marker.analyticType, marker.analyticGroup)"
            >
              <l-icon
                :icon-size="[38, 50]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/markeranalytic120/analytic120.svg')"
              />
              <l-popup
                ref="popup"
              >
                <div>
                  <span style="font-size: 17px; color:#fff;">วิเคราะห์</span>
                  <b-table
                    class="table table-borderless"
                    style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                    responsive="lg"
                    :items="itemsCount"
                    :fields="fields"
                    small
                    stacked
                    foot-clone
                  >
                    <!-- <template #cell(connect)="data">
                        <b-badge
                          :variant="connect[1][data.value]"
                          style="font-size: 13px;"
                        >
                          {{ connect[0][data.value] }}
                        </b-badge>
                      </template> -->
                    <template
                      #cell(id)="data"
                      colspan="2"
                    >
                      <b-button
                        v-if="marker.analyticType === 0"
                        id="toggle-btn"
                        :to="{ path: `/analytic-detail?wid=${data.item.id}&type=${data.item.analyticGroup}` }"
                        variant="success"
                      >
                        <span>ดูเพิ่มเติม</span>
                      </b-button>
                      <b-button
                        v-if="marker.analyticType === 1"
                        id="toggle-btn"
                        :to="{ path: `/analytic-detailCarstop?wid=${data.item.id}&type=${data.item.analyticGroup}` }"
                        variant="success"
                      >
                        <span>ดูเพิ่มเติม</span>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </l-popup>
            </l-marker>
          </l-map>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
// import Hls from 'hls.js'
import {
  BRow, BCol, BTable, BButton, BLink, BImg, BCard,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    BTable,
    BButton,
    BLink,
    BImg,
    BCard,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 12,
      center: [0, 0],
      wayname: '',
      waydetail: '',
      markers: [],
      video: '',
      check: false,
      camdesc: '',
      userData: JSON.parse(localStorage.getItem('userData')),
      itemsCount: [],
      fields: [
        { key: 'detail', label: 'จุดติดตั้ง:', class: 'text-center' },
        { key: 'WayID', label: 'สายทาง:', class: 'text-center' },
        { key: 'id', label: '', class: 'text-center' },
      ],
      type_name: '',
      qrcode: '',
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // ทำ action ที่คุณต้องการเมื่อ path เปลี่ยน (แม้เป็น path เดิม)
      this.getMarkerCount()
      this.qrcode = this.$route.query.DeptID
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getMarkerCount()
  },
  mounted() {
    this.qrcode = this.$route.query.DeptID
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())
  },
  methods: {
    zoomUpdated(value) {
      axios
        .post('/updateMapZoomSub', {
          mapzoom_master: value, deptid: this.$route.query.DeptID, type_name: this.type_name,
        })
        .then(response => {
          console.log(response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMarkerCount() {
      axios
        .post('/getMarkerAnalyticSub', { DeptID: this.$route.query.DeptID, username: this.userData.username })
        .then(response => {
          this.zoom = response.data[0].mapzoom_master
          this.center = []
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.waydetail = response.data[0].detail
          this.markers = response.data
          this.wayname = response.data[0].DeptName2
          this.type_name = response.data[0].type_name
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInfoCount(WayID, detail, id, analyticType, analyticGroup) {
      this.itemsCount = []
      this.itemsCount.push({
        WayID,
        detail,
        id,
        analyticType,
        analyticGroup,
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  .leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
  .leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.85);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}

</style>
